import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../app/hooks";
import { SCHEDULING_PERIOD_TYPES } from "../../../settings/helpers/utils";
import { StyledFormSection } from "../styles";
import LabelSelectRow from "./LabelSelectRow";

const SalaryAndInvoicingPeriodsSection = () => {
  const { t } = useTranslation(["customers", "schedulingPeriods"]);
  const options = SCHEDULING_PERIOD_TYPES.map((type) => type.id);
  const { schedulingClass } = useAppSelector((state) => state.localized);
  const getLocalizedValue = (value: string) => schedulingClass[value];
  return (
    <StyledFormSection
      title={t("schedulingPeriods:schedulingAndBillingPeriods")}
      noBorder
      disablePaddingBottom
    >
      <LabelSelectRow
        label={t("contract.hourlyWorkers")}
        fieldName="hourlyWorkersSchedulingClassId"
        options={options}
        getDisplayValue={getLocalizedValue}
        disabled
      />
      <LabelSelectRow
        label={t("contract.monthlyWorkers")}
        fieldName="monthlyWorkersSchedulingClassId"
        options={options}
        getDisplayValue={getLocalizedValue}
        disabled
      />
    </StyledFormSection>
  );
};

export default SalaryAndInvoicingPeriodsSection;
